import Auth from 'live/services/authorization'
import { getPermissionsLoggedUser } from '../api/permissionApi';

const ADMIN_ABLEON = "ADMIN_ABLEON";
const COMPANIES_ADMIN = "COMPANIES_ADMIN";
const MANAGE_COMPANY = "MANAGE_COMPANY";
const SUPER_USER = "SUPER_USER";

export function canManageCompany () {
    return Auth.Permission.isAdmin || Auth.Permission.MANAGE_COMPANY || Auth.Permission.COMPANIES_ADMIN
}

export function canCreateCompanies () {
  return Auth.Permission.isAdmin || Auth.Permission.COMPANIES_ADMIN
}

export const canEditCompany = (permissions) => {
  return permissions.some(permission =>  permission === ADMIN_ABLEON || permission === SUPER_USER)
}

export const canDeleteCompany = (permissions) => {
  return permissions.some(permission =>  permission === ADMIN_ABLEON || permission === SUPER_USER)
}
